import { createEditorService } from '@workpay/ds-shared/services/editorService';
import { publicClient } from '@lib/axios';

export const editorService = createEditorService(publicClient);
